import Image from "next/image";
import IconButton from "@mui/material/IconButton";

import { Preload } from "@/src/component/partial/Preload";
import { FrontendTrackingService, PostTrackingLogInput } from "@/src/service";

import styles from "./HeroCards.module.scss";

interface HeroCardsCarouselButtonsProps {
  nextClassName: string;
  prevClassName: string;
  className?: string;
  classes?: {
    prevClassName?: string;
    nextClassName?: string;
  };
  color?: "primary" | "secondary";
  tracking?: PostTrackingLogInput;
}

function HeroCardsCarouselButtons({ prevClassName, nextClassName, className, classes, color, tracking }: HeroCardsCarouselButtonsProps) {
  const preloadImages = color === "primary" ? ["/image/icon_arrow_down_thick_dark.svg"] : ["/image/icon_arrow_down_thick.svg"];
  return (
    <div className={className}>
      <Preload images={preloadImages} />
      <IconButton
        id={prevClassName}
        aria-label="Back Button"
        className={classes?.prevClassName}
        onClick={
          tracking
            ? () => {
                FrontendTrackingService.postTrackingLog(tracking);
              }
            : undefined
        }
      >
        <Image
          src={color === "primary" ? "/image/icon_arrow_down_thick_dark.svg" : "/image/icon_arrow_down_thick.svg"}
          width={40}
          height={40}
          alt="Previous Card"
          className={styles.prev}
        />
      </IconButton>
      <IconButton
        id={nextClassName}
        aria-label="Forward Button"
        className={classes?.nextClassName}
        onClick={
          tracking
            ? () => {
                FrontendTrackingService.postTrackingLog(tracking);
              }
            : undefined
        }
      >
        <Image
          src={color === "primary" ? "/image/icon_arrow_down_thick_dark.svg" : "/image/icon_arrow_down_thick.svg"}
          width={40}
          height={40}
          alt="Previous Card"
          className={styles.next}
        />
      </IconButton>
    </div>
  );
}

export default HeroCardsCarouselButtons;
